var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6018 28.875C49.1269 42.9844 55.125 47.25 55.125 47.25H7.875C7.875 47.25 15.75 41.6509 15.75 22.05C15.75 17.5954 17.409 13.3219 20.3621 10.1719C23.3179 7.02187 27.3262 5.25 31.5 5.25C32.3846 5.25 33.264 5.32875 34.125 5.48625M36.0412 55.125C35.5803 55.9212 34.9181 56.5823 34.121 57.0418C33.3239 57.5014 32.4201 57.7433 31.5 57.7433C30.5799 57.7433 29.6761 57.5014 28.879 57.0418C28.0819 56.5823 27.4197 55.9212 26.9588 55.125M49.875 21C51.9636 21 53.9666 20.1703 55.4435 18.6935C56.9203 17.2166 57.75 15.2136 57.75 13.125C57.75 11.0364 56.9203 9.03338 55.4435 7.55653C53.9666 6.07969 51.9636 5.25 49.875 5.25C47.7864 5.25 45.7834 6.07969 44.3065 7.55653C42.8297 9.03338 42 11.0364 42 13.125C42 15.2136 42.8297 17.2166 44.3065 18.6935C45.7834 20.1703 47.7864 21 49.875 21Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.538332781733a371df880bc2982414a8.svg";
export { ForwardRef as ReactComponent };